<template>
  <!-- 国内改签详情 -->
  <div>
    <div class="Details_data">
      <h4>订单信息</h4>
      <div class="Details_text">
        <span>改签单号：{{detailData.changeOrderNo||defaultText}}</span>
        <span @click="goAirDetail
          ">
          订单号：
          <span style="color:#237dc8;cursor:pointer;">{{detailData.orderNo}}</span>
        </span>
        <span>改签状态：{{detailData.changeStatusText||defaultText}}</span>
        <span>申请时间：{{detailData.appTime||defaultText}}</span>
        <span>航程类型：{{detailData.flightTypeText||defaultText}}</span>
        <span>订单总金额：￥{{detailData.orderAmount||defaultText}}</span>
        <span>改签时间：{{detailData.changeTime||defaultText}}</span>
        <span>补款金额：￥{{detailData.changePayAmount||defaultText}}</span>
        <span v-if="detailData.fullReductionAmount">实际支付金额：￥{{detailData.payAmount||defaultText}}</span>
        <span class="price" v-if="detailData.fullReductionAmount">
          优惠金额：￥{{detailData.fullReductionAmount||defaultText}}
          <el-popover placement="bottom" width="500" trigger="hover">
            <div
              class="activity_text"
              v-for="(item,index) in detailData.fullReductionSnapshot"
              :key="index"
            >
              <p>
                <b>{{index}}</b>
                {{item}}
              </p>
            </div>
            <b slot="reference">优惠说明</b>
          </el-popover>
        </span>
      </div>
    </div>
    <div class="content-list">
      <h2>航班信息</h2>
      <div class="content_table">
        <table width="95%">
          <tr>
            <th>航段</th>
            <th>航空公司</th>
            <th>航班号</th>
            <th>舱位</th>
            <th>舱位等级</th>
            <th>起抵地</th>
            <th>起飞时间</th>
            <th>到达时间</th>
          </tr>
          <tr v-for="(flight,index) in detailData.oldSegmentList" :key="index">
            <td>{{flight.segmentTypeText}}</td>
            <td>{{flight.airlineName}}</td>
            <td>{{flight.flightNo}}</td>
            <td>{{flight.cabinCode}}</td>
            <td>{{flight.cabinName}}</td>
            <td>
              {{flight.sCityName + flight.sAirportCode}}-
              {{flight.eCityName + flight.eAirportCode}}
            </td>
            <td>{{flight.beginDate}} {{flight.beginTime}}</td>
            <td>{{flight.arriveDate}} {{flight.arriveTime}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="content-list">
      <h2>乘客/改签航班信息</h2>
      <div
        class="content_table"
        v-for="(ticketPsg,index) in detailData.passengerList"
        :key="index"
        v-if="ticketPsg.segmentResultList.length>0"
      >
        <div class="passenger-list fs13">
          <span>乘客姓名：{{ticketPsg.psgName}}</span>
          <span>乘客类型：{{ticketPsg.psgTypeText}}</span>
          <span>证件类型：{{ticketPsg.cardTypeText}}</span>
          <span>证件号码：{{ticketPsg.cardNo}}</span>
        </div>
        <table width="95%" v-if="ticketPsg.segmentResultList.length>0">
          <tr>
            <th>航段</th>
            <th>航空公司</th>
            <th>航班号</th>
            <th>舱位</th>
            <th>舱位等级</th>
            <th>起抵地</th>
            <th>起飞时间</th>
            <th>到达时间</th>
            <th>原票号</th>
            <th>新票号</th>
            <th v-show="$route.query.psgType==2">成人票号</th>
          </tr>
          <tr v-for="(ticketFlight,index) in ticketPsg.segmentResultList" :key="index">
            <td>{{ticketFlight.segmentTypeText}}</td>
            <td>{{ticketFlight.airlineName}}</td>
            <td>{{ticketFlight.flightNo}}</td>
            <td>{{ticketFlight.cabinCode}}</td>
            <td>{{ticketFlight.cabinName}}</td>
            <td>
              {{ticketFlight.sCityName + ticketFlight.sAirportCode}}-
              {{ticketFlight.eCityName + ticketFlight.eAirportCode}}
            </td>
            <td>{{ticketFlight.beginDate}} {{ticketFlight.beginTime}}</td>
            <td>{{ticketFlight.arriveDate}} {{ticketFlight.arriveTime}}</td>
            <td>{{ticketFlight.oldTicketNumber}}</td>
            <td>{{ticketFlight.newTicketNumber}}</td>
            <td v-show="$route.query.psgType==2">
              <span @click="goPage">
                <span
                  style="color:#237dc8;cursor:pointer"
                >{{ticketFlight.adultTicketNumber|| '----'}}</span>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="content-list">
      <h2>申请内容</h2>
      <div class="fs13" style="padding: 15px 25px ">
        <p>
          <span>改签类型：{{detailData.chaReason==2?'非自愿改签':'自愿改签'}}</span>
        </p>
        <p>
          <span>变更类型：{{detailData.changeTypeText}}</span>
        </p>
        <p>
          <span>备注：{{detailData.remark}}</span>
        </p>
        <p class="img-box" v-show="detailData.chaReason==2">延误/病退证明：
          <el-image
            style="width: 100px; height: 100px"
            :src="detailData.img"
            :preview-src-list="detailData.imgList"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </p>
      </div>
    </div>
    <div class="content-list" v-show="!payType">
      <h2>改签说明</h2>
      <div class="mb20 fs14" style="padding:10px 25px;">
        <p class="mt10 mb10">1、平台退改工作时间:8：30 ~ 22：00（周一至周日）请您提交改签时尽量在工作时段内提交，避免产生损失；</p>
        <p class="mt10 mb10">2、改签相关费用提交申请后，由专属客服与您联系确认。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InlandOrderInfo",
  data() {
    return {
      defaultText: "-----"
    };
  },
  props: ["detailData", "payType"],
  watch: {},
  methods: {
    goPage(val) {
      if (!val) return;
      this.$router.push({
        name: "air-ticket-admin-international-list-detail",
        query: { ordersNo: val }
      });
    },
    goAirDetail() {
      this.$router.push({
        name: "air-ticket-admin-airDetails",
        query: { ordersNo: this.detailData.orderNo }
      });
      this.$nextTick(() => {
        setTimeout(() => {
          this.$router.go(0);
        }, 100);
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";
.content-list {
  @contentBox();
  .img-box {
    display: flex;
    align-items: stretch;
  }
}
.content_table {
  @contentTable();
}
.content_table-color {
  @contentTableColor();
}
.luggage-info {
  padding: 10px 25px;
  p {
    padding: 5px 0;
  }
}

.Details_data {
  background: #fffcfa;
  border: solid 1px #ffb27f;
  h4 {
    padding-left: 30px;
    color: #666666;
    font-size: 16px;
    font-weight: 400;
    padding: 8px 30px;
    background: #fff5ef;
  }
  .Details_text {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 20px 30px;
    span {
      display: inline-block;
      width: 33%;
      font-size: 13px;
      color: #666;
      line-height: 25px;
      height: 25px;
    }
    .price {
      b {
        cursor: pointer;
        color: #237dd2;
      }
    }
  }
}
.passenger-list {
  padding: 10px 25px;
  background: #ecf6ff6e;
  border-bottom: 1px dashed #dfdfdf;
  span {
    padding-right: 40px;
  }
}
.fs13 {
  p {
    padding: 5px 0;
  }
}
.activity_text {
  font-size: 13px;
  color: #666;
  text-align: justify;
  p {
    line-height: 25px;
  }
}
</style>
